<template>
    <div class="news-item" v-if="content" v-on:click.stop="gotoDetail(content.contentId)">
        <div class="news-cover">
            <img v-lazy="content.logo" v-if="content.logo"/>
        </div>
        <div class="news-content">
            <div class="news-title">
                <p>{{content.contentTitle}}</p>
            </div>
            <div class="news-desc">
                <p>{{content.summary}}</p>
            </div>
            <div class="detail">
                <div class="detail-btn">
                查看详情
                </div>
            </div>
        </div>
    </div>

</template>
<script>
export default {
    props:{
        content: {
            type: Object,
            default: () => {},
        },
    },
    methods:{
        gotoDetail(contentId){
            this.$router.push("/newsDetail?contentId="+ contentId);
        }
    }
}
</script>

<style scoped>
.news-item{
    display: flex;
    cursor: pointer;
    position: relative;
    margin-bottom: 76px;
}
.news-cover{
    width: 206px;
    height: 106px;
    display: flex;
    align-items: center;
    overflow: hidden;
    border: 1px solid #ccc;
}
.news-content{
    display: inline-block;
    margin-left: 15px;
}
.news-cover img{
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
}
.news-title, .news-desc{
    width: 900px;
}
.news-title:hover{
    color: #C92A3A;
}
.news-title p{
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    font-weight: bold;
    margin-top: 12px;
    line-height: 24px;
    margin-bottom: 5px;
}
.news-desc p{
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    font-size: 12px;
    line-height: 18px;
    color: #858585;
}
.detail{
    position: absolute;
    bottom: 0;
    left: 221px;
}
.detail-btn{
    display: inline-block;
    border: 1px solid #727171;
    width: 86px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #595757;
}
.detail-btn:hover{
    background-color: #C92A3A;
    color: white;
    border: 1px solid #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/NewsItemList.vue